import React, {forwardRef} from "react";
// core components
import GridItem from "components/Grid/GridItem.js";
// date components
import ptLocale from 'date-fns/locale/pt';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
//css customization
import blue from "@material-ui/core/colors/blue";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: blue["700"],
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: blue["700"],
      },
      dayDisabled: {
        color: blue["400"],
      },
      current: {
        color: blue["700"],
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: blue["700"],
      },
    },
  },
});

export const DateInput = forwardRef((props, ref) => {
  const fieldsize = props.fieldsize ? props.fieldsize : 12

  return (
    <GridItem xs={12} sm={12} md={fieldsize}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptLocale}>
          <ThemeProvider theme={materialTheme}>
            <KeyboardDatePicker variant="inline" format="dd/MM/yyyy" {...props}/>
          </ThemeProvider>
        </MuiPickersUtilsProvider>
    </GridItem>
    )
})
